import { Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSelectedVideos, getVideos } from '../../api/video';
import { useAuth } from '../../contexts/auth';
import { useMenuContext } from '../../contexts/menuContextProvider';

import VideoItem from '../../components/video/video-item/VideoItem';

export default function Video() {
  const { menuContext } = useMenuContext();
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const { signOut } = useAuth();
  const [selectedVideos, setSelectedVideos] = useState([]);

  useEffect(() => {
    if (menuContext) {
      getVideos(menuContext.type, menuContext.key).then((d) => {
        if (d.authFailed) {
          signOut();
        } else {
          setVideos(d);
        }
      });

      getSelectedVideos().then((vv) => {
        setSelectedVideos(vv);
      });
    } else {
      navigate('/home');
    }
  }, [menuContext, signOut, navigate]);

  if (!menuContext) {
    navigate('/home');
    return null;
  }
  const isVideoInList = (videoId) => {
    return selectedVideos?.some((item) => item.videoId === videoId);
  };
  return (
    <Box
      elevation={3}
      p={3}
      m={3}
      sx={{
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant='h4'
        textAlign='center'
        gutterBottom
        sx={{ marginBottom: 3 }}
      >
        {menuContext.title}
      </Typography>

      <Stack
        spacing={4}
        direction='column'
        flexWrap='wrap'
        justifyContent='center'
        sx={{ width: '80%', minHeight: 500 }}
      >
        {videos.length > 0 ? (
          videos.map((v) => (
            <VideoItem
              key={v.key}
              videoTitle={v.title}
              videoText={v.text}
              videoKey={v.key}
              videoURL={v.videoUrl}
              accessNeeded={v.accessNeeded}
              freeVideo={isVideoInList(v.key)}
              onReloadRequest={async () => {
                const vv = await getSelectedVideos();
                setSelectedVideos(Array.isArray(vv) ? vv : []);
              }}
            />
          ))
        ) : (
          <Typography variant='h6' color='textSecondary' textAlign='center'>
            Nincsenek elérhető videók.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
